import { Link } from 'react-router-dom';
import type { Comic } from '@/types/comic';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 免费韩漫在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 text-xs rounded-full font-medium ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-foreground-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-yellow-400 text-xs"></i>
            </div>
            <span>{comic.rating}</span>
            <span className="opacity-60">|</span>
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line text-xs"></i>
            </div>
            <span>{comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1">{comic.author}</p>
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {comic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 text-xs bg-secondary-100 text-secondary-800 rounded">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}